/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N4Inputs */

const en_to_xml_ref_n4 = /** @type {(inputs: To_Xml_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampersand, less than, greater than, and double quote are escaped in text content.`)
};

const ko_to_xml_ref_n4 = /** @type {(inputs: To_Xml_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앰퍼샌드, 부등호, 큰따옴표가 텍스트 내용에서 이스케이프됩니다.`)
};

const ja_to_xml_ref_n4 = /** @type {(inputs: To_Xml_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンパサンド、小なり、大なり、二重引用符がテキスト内容でエスケープされます。`)
};

/**
* | output |
* | --- |
* | "Ampersand, less than, greater than, and double quote are escaped in text content." |
*
* @param {To_Xml_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n4 = /** @type {((inputs?: To_Xml_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n4(inputs)
	if (locale === "ko") return ko_to_xml_ref_n4(inputs)
	return ja_to_xml_ref_n4(inputs)
});